import React from "react";

import * as Icons from "/component/base/Icon";
import Text from "/component/base/Text";
import { layout } from "/styles";
import { formatDate } from "/util/date";

import { ContentWrapper, DotIcon, TextContent, TitleContent } from "./DocumentListItem.styles";

interface Props {
  title: string;
  providerName: string;
  dateString: string;
  unread: boolean;
}

const DocumentListItem = ({ title, providerName, dateString, unread }: Props) => {
  const subTitle = providerName;
  const docDate = formatDate(dateString, "MMMM dd, yyyy");

  return (
    <div
      css={[
        layout.flexCenterHorizontal,
        layout.margin("standard", "none"),
        layout.spacedChildrenHorizontal("standard"),
      ]}
    >
      {unread && <DotIcon />}
      <div>
        <Icons.FileText
          color="brandSecondary"
          background={{ size: 48, color: "brandSecondaryLight" }}
        />
      </div>
      <ContentWrapper>
        <TextContent>
          <TitleContent>
            <Text color={"textPrimary"} variant="body1Bold">
              {title}
            </Text>
          </TitleContent>

          {subTitle && (
            <Text color="textSecondary" variant="body2">
              {subTitle}
            </Text>
          )}

          <Text variant="body2" color="textSecondary">
            {docDate}
          </Text>
        </TextContent>
      </ContentWrapper>
    </div>
  );
};

export default DocumentListItem;
